module.exports = __webpack_public_path__ + "files/01eb43ad73f213fb6d0c02d6e466002c.png";